module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-category-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-offset-11 text-right"
  }, [_c('common-cost-button-modal', {
    on: {
      "itemUpdated": _vm.itemUpdated
    }
  })], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('base-list', {
    ref: "list",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b7ffd63!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CommonCostList.vue
// module id = 2180
// module chunks = 1